import { useCallback, useContext } from 'react';

import { CLIENT_BALANCE_MAX } from '@app/constants';
import {
  CHF_BALANCE_E,
  CHF_BALANCE_S,
  CHF_CLIENTS_FILTER,
} from '@app/pages/Clients/ClientsList/constants/filterKeysAndIds';
import { ClientFiltersContext } from '@app/providers';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

import { RangeWithStartAndEnd } from '.';

export const ClientsBalance = ({
  includedFiltersIndex,
  labelClassName,
}: {
  includedFiltersIndex: number;
  labelClassName: string;
}) => {
  const { filters, setFilters } = useContext(ClientFiltersContext);
  const Values = filters.ClientsFilter?.[includedFiltersIndex]?.Values?.[0];
  const handleChange = useCallback(
    (value: string | number | null, filterGroupKey: string): void => {
      const hasNumericValue = value || value === 0;

      setFilters({
        ...(filters || []),
        ClientsFilter: [
          ...(filters.ClientsFilter.filter(
            (_, index) => index !== includedFiltersIndex
          ) || []),
          {
            ...filters.ClientsFilter?.[includedFiltersIndex],
            Values: [
              {
                ...Values,
                [filterGroupKey]: hasNumericValue ? +value : null,
              },
            ],
          },
        ],
      });
    },
    [filters, includedFiltersIndex, setFilters, Values]
  );

  return (
    <RangeWithStartAndEnd
      labelClassName={labelClassName}
      fieldClassName="client-balance"
      minValue={Values?.BalanceS}
      maxValue={Values?.BalanceE}
      filterGroupKey={CHF_CLIENTS_FILTER}
      // Временное решение, планируется убрать "as" в рамках task/3444.
      // Было внедрено, поскольку без него имелось порядка 10 конфликтов типизации.
      // Вероятнее всего, правки для него потребуется вносить на уровне сервиса "Клиенты"
      filterUnitKey={CHF_BALANCE_S as NClientsList.FilterUnitValueKey}
      filterUnitMaxKey={CHF_BALANCE_E as NClientsList.FilterUnitValueKey}
      filterGroupIndex={includedFiltersIndex}
      handleMinChange={(value) => handleChange(value, 'BalanceS')}
      handleMaxChange={(value) => handleChange(value, 'BalanceE')}
      min={-CLIENT_BALANCE_MAX}
      max={CLIENT_BALANCE_MAX}
      withNegativeValues
    />
  );
};
